<app-enfaf-modal
  [title]="!!data ? 'Editar vídeo' : 'Nuevo vídeo'"
  (onClose)="closeModal()"
  (onConfirm)="onConfirm()"
  buttonCancelText="Cancelar"
  buttonConfirmText="Guardar"
  [disableCancelButton]="isLoading()"
  [disableConfirmButton]="isLoading()"
  svgIcon="video-dark"
  [disableConfirmButton]="form.invalid"
>
  <form class="form" [formGroup]="form">
    <div>
      <enfaf-input color="light" label="Título" placeholder="Título" errorLabel="El Título es requerido" [control]="form.controls.title">
      </enfaf-input>
    </div>
    <div>
      <enfaf-input
        color="light"
        label="ID de video de Vimeo"
        placeholder="123456789"
        errorLabel="El ID de Vimeo es requerido"
        [control]="form.controls.vimeoId"
      >
      </enfaf-input>
    </div>
  </form>

  @if (safeUrl) {
    <div class="video-container">
      <div class="video">
        <iframe [src]="safeUrl" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" id="iframe-modal-ambassador-info-preview"></iframe>
      </div>
    </div>
  }
</app-enfaf-modal>
